import { render, staticRenderFns } from "./dropdown-trigger.vue?vue&type=template&id=3fd9bff9&scoped=true&"
import script from "./dropdown-trigger.vue?vue&type=script&lang=js&"
export * from "./dropdown-trigger.vue?vue&type=script&lang=js&"
import style0 from "./dropdown-trigger.vue?vue&type=style&index=0&id=3fd9bff9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd9bff9",
  null
  
)

export default component.exports